module.exports = __webpack_public_path__ + "media/images/access-options-3f542b9e07b00b801fb0c27dc11f9c61.svg";